import { Button, Stack, Typography } from '@mui/material'

/** The recipients a write would reach, as one readable line. */
function audience(principal) {
  const values = Object.values(principal ?? {}).filter(
    (value) => typeof value === 'string' || typeof value === 'number',
  )
  return values.length ? values.join(', ') : null
}

/**
 * One waiting action. Recipient first, deliberately: it is the fact that
 * decides whether approving is safe, and burying it under a tool slug is how
 * a user approves a message to the wrong person.
 */
export default function PendingApprovalRow({ proposal, busy, onDecide }) {
  const to = audience(proposal.principal)
  return (
    <Stack
      direction="row"
      sx={{
        gap: 1.5,
        alignItems: 'center',
        py: 1.25,
        borderBottom: '1px solid var(--app-border-light)',
      }}
    >
      <Stack sx={{ flex: 1, minWidth: 0, gap: 0.25 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600 }} noWrap>
          {to ? `${proposal.summary} → ${to}` : proposal.summary}
        </Typography>
        <Typography sx={{ fontSize: 12, color: 'var(--app-text-tertiary)' }} noWrap>
          {proposal.tool}
          {proposal.toolkit ? ` · ${proposal.toolkit}` : ''}
        </Typography>
      </Stack>
      <Button size="small" variant="contained" disabled={busy} onClick={() => onDecide(true)}>
        Approve
      </Button>
      <Button size="small" variant="text" disabled={busy} onClick={() => onDecide(false)}>
        Cancel
      </Button>
    </Stack>
  )
}
